import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProfilePrompt = ({ currentUser }) => {
  // Check if essential fields are missing
  const isMissingInfo = !currentUser?.name || 
                       !currentUser?.gradYear || 
                       !currentUser?.linkedIn;

  if (!isMissingInfo) return null;

  let toAdd = []
  if (!currentUser?.name) {
      toAdd.push("name")
  }
  if (!currentUser?.gradYear) {
      toAdd.push("grad year")
  }
  if (!currentUser?.linkedIn) {
      toAdd.push("LinkedIn")
  }
  
  let str = null;
  let val = '100%';
  if (toAdd.length == 1) {
      str = toAdd[0];
      val = '66%';
  }
  if (toAdd.length == 2) {
      str = toAdd.join(" and ");
      val = '33%';
  }
  if (toAdd.length > 2) {
      str = toAdd.slice(0, -1).join(", ")
      str = str + ", and " + toAdd[toAdd.length-1]
      val = '0%';
  }

  return (
    <div className="fixed bottom-8 sm:bottom:4 z-[5000] right-4 max-sm:left-4 bg-yellow-50 p-4 rounded-lg shadow-lg border border-yellow-200 max-w-md">
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5" />
        <div>
          <h3 className="text-sm font-medium text-yellow-800">
            Complete Your Profile
          </h3>
          <p className="mt-1 text-sm text-yellow-700">
            Your profile is missing important information, please consider adding it!
          </p>
          <div class="flex justify-between my-1">
            <span class="text-sm font-medium text-yellow-700">Todo: {str}</span>
            <span class="text-sm text-gray-600"></span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-2.5">
            <div class="bg-yellow-600 h-2.5 rounded-full" style={{width: val}}></div>
          </div>
          <Link 
            to="/edit-profile" 
            className="mt-4 inline-block text-sm font-medium text-yellow-800 hover:text-yellow-900 underline"
          >
            Edit Profile →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProfilePrompt;